import script from "./LoginPc.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPc.vue?vue&type=script&setup=true&lang=js"

import "./LoginPc.vue?vue&type=style&index=0&id=6dc4e049&lang=css"
import "./LoginPc.vue?vue&type=style&index=1&id=6dc4e049&lang=scss&scoped=true"

import exportComponent from "D:\\psy\\项目\\guofang\\oldgfzs\\home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc4e049"]])

export default __exports__